// Shared helpers to build white-label CRM deep links.
//
// The base URL comes from the backend env var `EMPLOYZ_BASE_URL` (default
// https://app.leadconnectorhq.com if the operator hasn't customized it).
// Backend echoes it back on every GHL connection response as `ui_base_url`
// AND on GET /api/config/ui for pages that don't already have the connection.
//
// Never hardcode `app.leadconnectorhq.com` / `app.gohighlevel.com` again —
// always build links through these helpers.
import api from "./api";

let _cachedBase = null;

export function normalizeBase(u) {
  return (u || "https://app.leadconnectorhq.com").replace(/\/$/, "");
}

export async function getCrmBaseUrl() {
  if (_cachedBase) return _cachedBase;
  try {
    const r = await api.get("/config/ui");
    _cachedBase = normalizeBase(r.data?.ui_base_url);
  } catch (_e) {
    _cachedBase = normalizeBase(null);
  }
  return _cachedBase;
}

export function crmContactUrl(baseUrl, locationId, contactId) {
  return `${normalizeBase(baseUrl)}/v2/location/${locationId}/contacts/detail/${contactId}`;
}

export function crmLocationSettingsUrl(baseUrl, locationId, section = "custom-fields") {
  return `${normalizeBase(baseUrl)}/v2/location/${locationId}/settings/${section}`;
}
